import {SingleVehicleRoute} from "@/services/router/sponsor/vehicles";
import {BasicNavigator} from "@/core/navigation/BasicNavigator";

export class VehiclesNavigator extends BasicNavigator {
    public single(id: string) {
        return this.route(SingleVehicleRoute, {vehicleId: id})
    }
}
